import { ICellRendererParams } from 'ag-grid-community';
import { TokenBalance } from '../../types';

// Pre-create formatter for performance (expensive to create repeatedly)
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const ValueCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const value = params.value as number;

  if (value === null || value === undefined) {
    return <span className="text-muted-foreground">-</span>;
  }

  // Use pre-created formatter for better performance
  const formattedValue = currencyFormatter.format(value);

  // Check if value is very small (rounds to $0.00 but is actually > 0)
  const isVerySmall = value > 0 && value < 0.01;
  const displayValue = isVerySmall ? `≈${formattedValue}` : formattedValue;

  return (
    <span className="font-mono font-medium text-foreground">
      {displayValue}
    </span>
  );
};
